<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <div class="row">
            <div class="col">
              <h3 class="page-title">Visitors</h3>
            </div>
            <div class="col-auto text-right">
              <a
                style="display: none"
                class="btn btn-white filter-btn"
                href="javascript:void(0);"
                id="filter_search"
                @click="toggleShowFilters"
              >
                <i class="fas fa-filter"></i>
              </a>
              <button
                class="btn btn-primary first-button ml-2"
                data-toggle="modal"
                href="#create_visit_modal"
              >
                <i class="fas fa-plus"></i> Book Visitor
              </button>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Search Filter -->
        <div v-if="showFilters" class="card filter-card" id="filter-inputs">
          <div class="card-body pb-0">
            <form>
              <div class="row filter-row">
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label>Name</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="filters.name"
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <button
                      class="btn btn-primary btn-block"
                      type="button"
                      @click="retrieveVisits"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- /Search Filter -->

        <div ref="visitsContainer" class="row vld-parent">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-0"></div>
                  <div class="col-sm-12 col-md-12">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <select
                          class="input-group-text form-control bg-primary"
                          v-model="selectedSearchFilterId"
                          @change="changeSearchFilter"
                          :required="true"
                        >
                          <option
                            v-for="searchFilter in searchFilters"
                            :key="searchFilter"
                            :value="searchFilter"
                            :name="searchFilter"
                            :selected="searchFilter"
                          >
                            {{ searchFilter }}
                          </option>
                        </select>
                      </div>
                      <input
                        class="form-control"
                        type="text"
                        v-model="searchValue"
                        @keyup="searchVisits($event)"
                        placeholder="Search visitors..."
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div class="table table-responsive">
                  <div>
                    <table
                      id="tblVisits"
                      class="table table-hover table-center mb-0 datatable"
                      :class="windowWidth < 768 ? 'cards' : '-'"
                    >
                      <thead style="background-color: ghostwhite">
                        <tr class="text-center">
                          <th scope="col" class="text-left">Access Code</th>
                          <th scope="col" class="text-left">Visitor</th>
                          <!--                        scope="col" <th class="text-left">Visiting</th>-->
                          <!--                        scope="col" <th class="text-left">Destination</th>-->
                          <th scope="col" class="text-left">Start Date</th>
                          <th scope="col" class="text-left">End Date</th>
                          <th scope="col" class="text-left">Status</th>
                          <th scope="col" class="text-right"></th>
                          <!--                        <th class="text-right">Action</th>-->
                        </tr>
                      </thead>
                      <tbody v-if="visits.length">
                        <tr
                          class="text-center clickable-row"
                          v-for="visit in visits"
                          :key="visit.id"
                          @click="viewVisit(visit.id)"
                        >
                          <td
                            col="Access Code: "
                            class="text-left"
                            style="font-weight: 600; letter-spacing: 2px;"
                          >
                            {{ visit.accessCode ? visit.accessCode : "-" }}
                          </td>
                          <td col="Visitor: " class="text-left">
                            <span
                              v-if="
                                visit.bookingType === 'DELIVERY' ||
                                  visit.bookingType === 'CONTRACTOR'
                              "
                            >
                              {{ visit.name || "-" }}
                            </span>
                            <span v-else-if="visit.visitor">
                              {{
                                getFullName(
                                  visit.visitor.firstName,
                                  visit.visitor.lastName
                                )
                              }}
                            </span>
                            <span v-else>
                              {{ getFullName(visit.firstName, visit.lastName) }}
                            </span>
                          </td>
                          <!--                        col="#ID: " <td class="text-left">{{ visit.visitee && visit.visitee.name ? visit.visitee.name : '-'}}</td>-->
                          <!--                        col="#ID: " <td class="text-left">{{ visit.destination && visit.destination.name ? visit.destination.name : '-'}}</td>-->
                          <td col="Start Date: " class="text-left">
                            {{
                              visit.startDateTime
                                ? utcDateToLocal(visit.startDateTime)
                                : "-"
                            }}
                          </td>
                          <td col="End Date: " class="text-left">
                            {{
                              visit.endDateTime
                                ? utcDateToLocal(visit.endDateTime)
                                : "-"
                            }}
                          </td>
                          <td col="Status: " class="text-left">
                            <label
                              v-if="visit.status === 'ACTIVE'"
                              class="badge badge-success"
                              >ACTIVE</label
                            >
                            <label
                              v-else-if="visit.status === 'BOOKED'"
                              class="badge badge-success"
                              >BOOKED</label
                            >
                            <label
                              v-else-if="visit.status === 'CHECKED_IN'"
                              class="badge badge-info"
                              >CHECKED IN</label
                            >
                            <label
                              v-else-if="visit.status === 'CHECKED_OUT'"
                              class="badge badge-primary"
                              >CHECKED OUT</label
                            >
                            <label
                              v-else-if="visit.status === 'CANCELLED'"
                              class="badge badge-secondary"
                              >CANCELLED</label
                            >
                            <label
                              v-else-if="visit.status === 'EXPIRED'"
                              class="badge badge-danger"
                              >EXPIRED</label
                            >
                            <label v-else class="badge badge-secondary">{{
                              visit.status
                            }}</label>
                          </td>
                          <td class="text-right">
                            <i class="fas fa-chevron-right text-muted"></i>
                          </td>
                          <td col="Status: " class="text-left" hidden>
                            <label
                              v-if="visit.status === 'PENDING'"
                              class="badge badge-secondary"
                              style="color: white"
                              >BOOKED</label
                            >
                            <label
                              v-else-if="visit.status === 'ACTIVE'"
                              class="badge badge-info"
                              style="color: white"
                              >BOOKED</label
                            >
                            <label
                              v-else-if="
                                visit.status === 'DONE' ||
                                  visit.status === 'BOOKED'
                              "
                              class="badge badge-success"
                              style="color: white"
                              >DONE</label
                            >
                            <label
                              v-else-if="visit.status === 'CANCELLED'"
                              class="badge badge-secondary"
                              style="color: white"
                              >CANCELLED</label
                            >
                            <label
                              v-else
                              class="badge badge-secondary"
                              style="color: white"
                              >{{ visit.status }}</label
                            >
                          </td>
                          <!--                        <td class="text-right text-white">-->
                          <!--                          <a class="btn btn-success" id="showEditVisitModal" data-toggle="modal" href="#edit_visit_modal" hidden></a>-->
                          <!--                          <a @click="editVisit(visit.id)" class="btn btn-sm bg-info-light">-->
                          <!--                            <i class="fa fa-edit mr-1"></i> Edit-->
                          <!--                          </a>-->
                          <!--                          <a @click="viewVisit(visit.id)" class="btn btn-sm bg-success-light">-->
                          <!--                            <i class="fa fa-eye mr-1"></i> View-->
                          <!--                          </a>-->
                          <!--                        </td>-->
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="!visits.length" class="text-center mt-5 mb-5">
                      <div>You don't have any visitors yet!</div>
                    </div>
                  </div>
                </div>

                <!--                <div v-if="!visits.length" class="text-center mt-5 mb-5">-->
                <!--                  <div>You don't have any visits yet</div>-->
                <!--                </div>-->
                <div v-if="visits.length" class="row">
                  <div class="col-sm-12 col-md-5">
                    <div
                      class=""
                      id="tblProducts_info"
                      visit="status"
                      aria-live="polite"
                      style="padding-top: 1.25em"
                    >
                      Show
                      <select
                        @change="onChangeRecordsPerPage"
                        v-model="recordsPerPage"
                      >
                        <option :value="5">5</option>
                        <option :value="10">10</option>
                        <option :value="20">20</option>
                        <option :value="30">30</option>
                        <option :value="40">40</option>
                        <option :value="50">50</option>
                      </select>
                      of {{ totalRecords }} entries
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-7">
                    <div
                      class="dataTables_paginate paging_simple_numbers"
                      id="tblProducts_paginate"
                      style="padding-top: 0.55em"
                    >
                      <pagination
                        :totalPages="totalPages"
                        :perPage="recordsPerPage"
                        :currentPage="currentPage"
                        @pagechanged="onPageChange"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Create Visit Modal -->
        <div
          class="modal fade"
          id="create_visit_modal"
          aria-hidden="true"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Create {{ $t("sidebar.visit") }}</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <!-- <CreateMedicalAppointmentForm v-if="this.$i18n.locale === 'medical'"/> -->
                <CreateVisitFormV2 v-if="this.$i18n.locale !== 'medical'" />
              </div>
            </div>
          </div>
        </div>
        <!-- Create Visit Modal -->

        <!-- Edit Visit Modal -->
        <div
          class="modal fade"
          id="edit_visit_modal"
          aria-hidden="true"
          role="dialog"
          ref="modal"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5 class="modal-title">Create {{ $t("sidebar.visit") }}</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form action="">
                  <div>
                    <div class="form-group">
                      <label>{{ $t("sidebar.visit") }} Number</label>
                      <input
                        readonly
                        type="text"
                        class="form-control"
                        v-model="visit.number"
                        ref="visitNumber"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group">
                      <label class="required">Name</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="visit.name"
                      />
                    </div>
                    <div class="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="visit.email"
                      />
                    </div>
                    <div class="form-group">
                      <label>Phone</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="visit.phone"
                      />
                    </div>
                    <div class="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="visit.address"
                      />
                    </div>
                    <div class="mt-4">
                      <button
                        class="btn btn-primary btn-block"
                        @click="updateVisit($event)"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Edit Visit Modal -->
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import moment from "moment";
import visitService from "../../service/appointment.service";
import { getFullName, utcDateToLocal } from "../../utils/utils";
import Pagination from "../Pagination";
import CreateVisitFormV2 from "../appointments/CreateVisitFormV2";

export default {
  name: "visits",
  components: {
    Pagination,
    // CreateVisitForm,
    CreateVisitFormV2
    // CreateMedicalAppointmentForm,
  },
  data() {
    return {
      visitId: null,
      visit: {},
      visits: [],
      showFilters: false,
      currentIndex: -1,
      searchValue: undefined,
      title: undefined,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 10,
      filters: {
        name: null
      },
      searchFilters: ["Code", "Name"],
      selectedSearchFilterId: "Code",
      fullPage: false,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false
    };
  },
  methods: {
    utcDateToLocal,
    getFullName: getFullName,
    formatToDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    formatTime(time) {
      return moment(time).format("HH:mm");
    },
    viewVisit(id) {
      this.$router.push(`/visits/${id}`);
    },
    viewVisitOwners(id) {
      this.$router.push(`/visits/${id}/owners`);
    },
    editVisit(id) {
      this.visitId = id;
      this.retrieveVisit(id);
      document.getElementById("showEditVisitModal").click();
    },
    retrieveVisit(id) {
      const customerId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");
      visitService
        .findById(customerId, id)
        .then(response => {
          this.visit = response.data.data;
        })
        .catch(e => {
          console.log(e);
          if (
            e.response.status === 401 ||
            e.response.status === 403 ||
            e.response.status === 409
          ) {
            return;
          }
          this.fireNotification("error", "Oops", "Error occurred");
        });
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
    },
    changeSearchFilter() {
      this.searchVisits(null);
    },
    searchVisits(e) {
      e ? e.preventDefault() : null;
      const customerId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      let params = {
        page: this.currentPage,
        size: this.recordsPerPage,
        op: "like"
      };
      if (this.searchValue) {
        params[this.selectedSearchFilterId.toLowerCase()] = this.searchValue;
      }
      visitService
        .find(customerId, params)
        .then(response => {
          this.visits = response.data.data;
          this.totalPages = response.data.pagination
            ? response.data.pagination.totalPages
            : 0;
          this.totalRecords = response.data.pagination
            ? response.data.pagination.totalRecords
            : 0;
        })
        .catch(e => {
          if (
            e.response.status === 401 ||
            e.response.status === 403 ||
            e.response.status === 409
          ) {
            return;
          }
          this.fireNotification("error", "Error occurred", 5000);
        })
        .finally(() => {
          loader.hide();
        });
    },
    retrieveVisits() {
      const customerId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      const params = {
        page: this.currentPage,
        size: this.recordsPerPage
      };
      visitService
        .find(customerId, params)
        .then(response => {
          this.visits = response.data.data;
          this.totalPages = response.data.pagination.totalPages;
          this.totalRecords = response.data.pagination.totalRecords;
        })
        .catch(e => {
          console.log(e);
          if (
            e.response.status === 401 ||
            e.response.status === 403 ||
            e.response.status === 409
          ) {
            return;
          }
          this.fireNotification("warning", "Oops", "Error occurred");
        })
        .finally(() => {
          loader.hide();
        });
    },
    updateVisit(e) {
      e.preventDefault();
      const customerId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");
      let visit = {
        name: this.visit.name,
        phone: this.visit.phone,
        email: this.visit.email,
        address: this.visit.address,
        status: "ACTIVE"
      };
      visitService
        .update(customerId, this.visitId, visit)
        .then(response => {
          let success = response.data.success;
          if (success === true) {
            this.visit = response.data.data;
            document.getElementById("showEditVisitModal").click();
            this.retrieveVisits();
            Swal.fire({
              icon: "success",
              title: "Done",
              text: "Successfully updated",
              footer: '<a href="">Why do I have this issue?</a>'
            });
          } else {
            this.fireNotification("error", "Oops", response.data.narrative);
          }
        })
        .catch(e => {
          console.log(e);
          if (
            e.response.status === 401 ||
            e.response.status === 403 ||
            e.response.status === 409
          ) {
            return;
          }
          this.fireNotification("error", "Oops", "Error occurred");
        });
    },
    deleteVisit(visitId) {
      const customerId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");
      visitService
        .delete(customerId, visitId)
        .then(response => {
          let success = response.data.success;
          if (success) {
            this.success = true;
            this.visits = this.visits.filter(function(item) {
              return item.id !== visitId;
            });
            this.fireNotification("success", "Deleted", "Successfully deleted");
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.narrative,
              footer: '<a href="">Why do I have this issue?</a>'
            });
          }
        })
        .catch(e => {
          console.log(e);
          if (
            e.response.status === 401 ||
            e.response.status === 403 ||
            e.response.status === 409
          ) {
            return;
          }
          this.fireNotification("error", "Error occurred", 5000);
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.retrieveVisits();
    },
    onChangeRecordsPerPage() {
      this.retrieveVisits();
    },
    fireNotification(icon, message, timeout) {
      Swal.fire({
        toast: true,
        width: 300,
        position: "top-end",
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: timeout,
        timerProgressBar: true
      });
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    basedOnWindowWidth() {
      if (this.windowWidth > 768) {
        return true;
      }
      return false;
    }
  },
  watch: {
    windowWidth: function() {
      if (this.windowWidth < 768) {
        return (this.isMobileView = true);
      } else if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        return (this.isTabletView = true);
      } else {
        return (this.isDesktopView = true);
      }
    }
  },
  async mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
      return;
    }
    this.retrieveVisits();
  }
};
</script>
<style scoped>
:disabled {
  cursor: not-allowed;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #f8f9fa;
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) "";
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/visit/VisitList.vue